export default "__VITE_ASSET__DuFWkDs2__"